import { observable, action } from "mobx";
import _ from "lodash";
import { TARGET_AUDIENCES_MULTISELECT } from "components/create_workshop/constants";
import shortid from "shortid";
import validate from "validate.js";
import OnlineWorkshopService from "../services/OnlineWorkshopService";
class OrganizationWorkshopCreate {
  constructor() {
    this.initialState();
  }

  @action
  initialState = () => {
    this.workshopService = new OnlineWorkshopService();
    this.openedEntity = { type: "workshop" };
    // this.modules = [];
    this.workshop = {
      id: null,
      target_audience: [],
      start_date: null,
      end_date: null,
      start_time: null,
      end_time: null,
      title: "",
      summary: '',
      more_info: "",
      description: "",
      how_many_hours: "",
      cost: "",
      provider_logo: "",
      provider_bio: "",
      host: "",
      coupons_attributes: [],
      fee: false,
      limited_purchase: false,
      cpd_hours: false,
      contact_name: "",
      contact_email: "",
      contact_phone: "",
      website: "",
      provided_by: "",
      workshop_type: "organization",
      tickets_count: "",
      with_access_code: true,
      access_code: "",
      zoom_link: '',
      visibility: true,
      organization_id: null,
    };
    // this.modulesError = [];
    this.errors = [];
    this.questionsMap = new Map();
    // this.modulesDetailsMap = new Map();
    this.moduleDescriptionFile = [];
    this.questionDetailsFiles = [];
    this.entityToSave = null;
  };

  @action
  setDescription = (value) => {
    // console.log('action', value);
    this.workshop.description = value;
  }

  @action
  setSummary = (value) => {
    console.log('action summary', value.text);
    this.workshop.summary = value.text;
  }

  @observable workshop = {};

  @observable couponErrors = [];

  @observable errors = {};

  @observable modules = [];

  @observable entityToSave = null;

  @observable openedEntity = { type: "workshop" };

  @observable modulesError = [];

  @observable moduleDescriptionFile = [];

  @observable questionDetailsFiles = [];

  @observable modulesDetailsMap = new Map();

  @observable questionsMap = new Map();

  @action setCouponError = (newCouponErrors) => {
    this.couponErrors = newCouponErrors;
  }

  @action setQuizCount = (index, count) => {
    const emptyObjects = [...Array(count).fill().map(() => ({...{}}))];
    this.modules[index].questions_attributes = emptyObjects;
  };

  @action setQuiz = (index, q_index, data) => {
    if (!this.modules[index].questions_attributes.length) {
      const emptyObjects = [{}];
      this.modules[index].questions_attributes = emptyObjects;
    }

    this.modules[index].questions_attributes[q_index].text = data.text;
    this.modules[index].questions_attributes[q_index].correct =
      data.correct;

    // this.modules[index].questions_attributes[q_index].text =
    // data.textQuestion;
    // this.modules[index].questions_attributes[q_index].correct = String(
    // data.rightAnswer
  };

  @action clearQuestions_attributes = (index, type) => {
    this.modules[index].module_type = type;

    let currentModule = [...this.modules[index].questions_attributes];
    let deleteQuestionsIds = currentModule.map(question => question.id);
    deleteQuestionsIds = deleteQuestionsIds.filter(id => id);
    this.modules[index].questions_attributes = [];
    if (this.workshop.deleteThisIds) {
      this.workshop.deleteThisIds = this.workshop.deleteThisIds.concat(deleteQuestionsIds);
    } else {
      this.workshop.deleteThisIds = deleteQuestionsIds
    }
    // console.log('Deleted indexes are: ', this.workshop.deleteThisIds);

    // console.log("All questions erased!!");
  };

  @action handleChange = data => {
    const isLimitedKey = Object.keys(data)[0] === 'limited_purchase';
    if(isLimitedKey && !data.limited_purchase)
      this.workshop = _.assign(this.workshop, {...data, tickets_count: ""});
    else
      this.workshop = _.assign(this.workshop, data);
  };

  @action addModuleError = data => {
    this.modulesError.push(_.assign(data, { questionError: [] }));
  };

  @action removeModuleError = index => {
    if (this.modulesError.length > index)
      this.modulesError[index] = _.assign(
        {},
        { questionError: this.modulesError[index].questionError }
      );
  };

  @action clearModuleError = () => {
    this.modulesError = [];
  };

  @action
  handleChangeOpenedEntity = data => {
    this.openedEntity = data;
  };

  getModules = () => {
    const sortedModules = this.modules.sort((module_a, module_b) => (module_a.position_index || module_a.id) - (module_b.position_index || module_b.id));
    return sortedModules || [];
  };

  getWorkShop = () => {
    return this.workshop;
  };

  getErrors = () => {
    return this.errors;
  };

  @action changeHasModules = () => {
    if (this.modules === null) this.modules = _.assign([]);
    else this.modules = null;
  };

  @action
  addErrors = data => {
    this.errors = _.assign({}, this.errors, data);
  };

  @action
  emitCreateEntity = type => {
    if (type === "workshop") this.entityToSave = { type: "workshop" };
    else if (type === "module") {
      let id = this.modules.length - 1;
      this.entityToSave = { type: "module", entity: this.modules[id] };
    } else if (type === "question") {
      let questionId = this.modules[type.id].questions.length - 1;
      this.entityToSave = {
        type: "question",
        entity: this.modules[type.id].questions[questionId]
      };
    }
  };

  @action
  deleteFile = () => {
    this.workshop = _.assign(this.workshop, {
      file_name: null,
      file_size: null,
      more_info: "",
      questions: []
    });
  };

  @action setErrors = data => {
    this.errors = _.assign({}, data);
  };

  @action addEmptyModule = key => {
    this.modules.push({
      id: null,
      title: "",
      is_hidden: false,
      summary: "",
      details: "",
      documents: [],
      position_index: "",
      key: key,
      module_type: "quiz",
      questions_attributes: [],
      openedQuestion: -1,
      attachments_attributes: []
    });
    this.handleChangeOpenedEntity({ type: "module", id: key });
  };

  @action handleModuleChange = (data, index) => {
    let module = this.modules[index];
    const isPositionIndex = Object.keys(data)[0] === 'position_index';
    if(isPositionIndex) {
      if(!!module.position_index) {
        this.modulePosition = module.position_index;
      }
      if(this.modulePosition) {
        this.modules.forEach((prevModule, prevModuleIndex) => {
          if(Number(prevModule.position_index) === Number(data.position_index)) {
            this.modules[prevModuleIndex] = {
              ...this.modules[prevModuleIndex],
              position_index: this.modulePosition,
            };
          }
        });
      }
      this.modules[index] = {
        ...this.modules[index],
        position_index: data.position_index,
      };
    } else {
      _.assign(module, data);
    }
  };

  @action
  addQuestion = (index, key) => {
    this.modules[index].questions_attributes.push({
      key: key,
      text: "",
      attachments_attributes: []
    });
    this.openQuestion(index, key);
  };

  @action deleteModule = key => {
    let index = _.findIndex(this.modules, el => el.key === key);
    if (this.modulesError.length > index) this.modulesError.splice(index, 1);
    this.modules.splice(index, 1);
  };

  @action handleChangeQuestion = (module, question, data) => {
    _.assign(this.modules[module].questions_attributes[question], data);
  };

  @action addQuestionFile = (module, question, data) => {
    this.modules[module].questions_attributes[
      question
    ].attachments_attributes.push(_.assign({}, data));
  };

  @action openQuestion = (module, questionKey) => {
    this.modules[module] = _.assign(this.modules[module], {
      openedQuestion: questionKey
    });
  };

  @action deleteQuestionFile = (module, question, fileIndex) => {
    this.modules[module].questions_attributes[
      question
    ].attachments_attributes.splice(fileIndex, 1);
  };

  @action deleteQuestion = (module, question) => {
    if (this.modulesError.length > module)
      if (this.modulesError[module].questionError.length > question)
        this.modulesError[module].questionError.splice(question, 1);
    this.modules[module].questions_attributes.splice(question, 1);
  };

  @action
  addModuleFile = (moduleId, file) => {
    this.modules[moduleId].attachments_attributes.push(_.assign({}, file));
  };

  @action
  deleteModuleFile = (moduleId, fileId) => {
    this.modules[moduleId].attachments_attributes.splice(fileId, 1);
  };

  @action
  addQuestionError = (index, data) => {
    if (this.modulesError.length > index)
      this.modulesError[index].questionError.push(data);
  };

  @action
  removeQuestionError = (index, questionId) => {
    if (this.modulesError.length > index)
      this.modulesError[index].questionError[questionId] = {};
  };

  @action
  addFileToModule = object => {
    this.moduleDescriptionFile.push(object);
  };

  @action
  addFileToModuleDetails = (index, object) => {
    if (!this.modulesDetailsMap.has(index))
      this.modulesDetailsMap.set(index, { files: [object] });
    else {
      this.modulesDetailsMap.get(index).files.push(object);
    }
  };

  @action
  addFileToQuestionText = (moduleIndex, questionIndex, object) => {
    let key = `${moduleIndex}${questionIndex}`;
    if (!this.questionsMap.has(key)) {
      this.questionsMap.set(key, { files: [object] });
    } else {
      this.questionsMap.get(key).files.push(object);
    }
  };

  @action setWorkshop = workshop => {
    this.workshop = _.assign(
      {},
      this.workshop,
      this.workshopService.setWorkshop(workshop)
    );
  };

  @action setModules = modules => {
    this.modules = this.workshopService.setModules(modules);
  };

  @action
  handleChangeTargetAudience = data => {
    this.workshop.target_audience.push(data);
  };

  @action addErrorToBio = () => {
    this.errors = _.assign({}, this.errors, {
      provider_bio: ["Provider bio maximum 1000 symbols"]
    });
  };

  @action removeLogo = () => {
    this.workshop.provider_logo = null;
    this.workshop.provider_logo_url = null;
  };

  showRemoveLogo = () => {
    return this.workshop.provider_logo || this.workshop.provider_logo_url;
  };

  @action
  addEmptyCoupon() {
    this.workshop.coupons_attributes.push({
      code: "",
      cost: "",
      is_free: false,
      expiry_date: null,
      id: shortid.generate(),
      isNew: true
    });
  }

  getCouponById(id) {
    const indexOf = _.findIndex(
      this.workshop.coupons_attributes,
      el => el.id === id
    );
    if (indexOf === -1) return null;
    else return this.workshop.coupons_attributes[indexOf];
  }

  @action
  handleChangeCoupon(e, id) {
    let coupon = this.getCouponById(id);
    if (coupon) {
      _.assign(coupon, e);
    }
  }

  @action
  handleChangeCouponIsFree(is_free, id) {
    console.log(id)
    let coupon = this.getCouponById(id);
    console.log(coupon)
    if (coupon) {
      _.assign(coupon, is_free);
    }
  }

  @action
  validateCouponCode() {
    const codes = this.workshop.coupons_attributes;
    this.couponErrors = [];
    const uniqCoupons = [];
    codes.forEach(el => {
      const error = { id: el.id };
      const codeError = [];
      const costError = [];
      const newDateError = [];
      if (!el.code || el.code.length < 4 || el.code.length > 8) {
        codeError.push("Must be between 4-8 characters, lower case only");
      } else {
        let codePattern = validate.single(el.code, {
          format: {
            pattern: /^[a-z0-9]{4,8}/g,
            message: "Must be between 4-8 characters, lower case only"
          }
        });
        if (!_.isEmpty(codePattern)) codeError.push(codePattern[0]);
      }
      if (el.code && _.includes(uniqCoupons, el.code))
        codeError.push("Code must be unique");
      else uniqCoupons.push(el.code);
      let costPatern = undefined;
      if(!el.is_free) {
        costPatern = validate.single(el.cost, {
          format: {
            pattern: "[0-9]*.[0-9]{0,2}",
            message: "New price is invalid"
          }
        });
      }
      if (costPatern) costError.push(costPatern);

      const dateError = validate.single(el.expiry_date, {
        presence: { message: "Expiration date is required" }
      });
      if (dateError) newDateError.push(dateError);
      _.assign(error, {
        cost: costError,
        code: codeError,
        expiry_date: newDateError
      });
      this.couponErrors.push(error);
    });
  }

  couponHasErrors() {
    let hasError = false;
    this.couponErrors.forEach(el => {
      if (
        !_.isEmpty(el.cost) ||
        !_.isEmpty(el.code) ||
        !_.isEmpty(el.expiry_date)
      )
        hasError = true;
    });
    return hasError;
  }

  @action
  handleDeleteCoupon(id) {
    let coupons = this.workshop.coupons_attributes;
    const couponIndex = _.findIndex(coupons, el => el.id === id);
    if (couponIndex !== -1) {
      const currentCoupon = coupons[couponIndex];
      if (currentCoupon.isNew) {
        coupons.splice(couponIndex, 1);
      } else {
        coupons[couponIndex]._destroy = true;
        this.workshop = _.assign({}, this.workshop);
      }
    }
    const indexOf = _.findIndex(this.couponErrors, el => el.id === id);
    if (indexOf === -1) {
      this.couponErrors.splice(indexOf, 1);
    }
  }

  getCouponsErrorsById(id) {
    const indexOf = _.findIndex(this.couponErrors, el => el.id === id);
    if (indexOf === -1) return null;
    else return this.couponErrors[indexOf];
  }
}

export default new OrganizationWorkshopCreate();



// WEBPACK FOOTER //
// ./src/stores/OrganizationWorkshopCreate.js